const { cELM, getWindowHeight, getAnswerVariableCssClass } = require("../utils");
const Scroller = require("../components/scroller");
const Provider = require("../components/blocks/provider.js");
const Block = require("../components/blocks/index");
const ProgressBar = require("../components/progress-bar");
//const Notification = require("../components/notification");
const ScrollNotification = require("../components/scroll-notification");
const Chat = require("../chat");

class MedicationModuleV20 {
  constructor(type, value, parentRef) {
    this.type = type;
    this.value = value;
    this.parent = parentRef;
    const cssVariableKey = getAnswerVariableCssClass(value);
    this.elContainer = cELM("div", `component-block module_meds_eng v20 module_med_v20 ${cssVariableKey}`);
    this.elContainer.addELM(new Provider({ data: value }));
    this.contentHash = {};
    this.typingIndicator = null;
    this._element = null;
    window.skipMedication = this.skipMedication;
  }

  mapFormat(value) {
    const _self = this;
    const params = { data: value.values, answer: "medication-value" };

    switch (params.data.format) {
      case "medication-list":
        let statuses = Object.keys(params.data.values).map(function(k,v){
          return params.data.values[k]['status']
        })

        params.data.format = "list-yes-no";
        params.data.labels = ["medication", "dosage", "timesPerDay"];
        params.data.options = {
          buttonName: "Submit",
          alphabetical: true,
          yesToAll:{
            label: getLngTxt('medication.yesToAll'),
            status: statuses
          }
        };

        break;
      case "selected-list":
        params.data.values = formatMedsList(params.data.values);
        params.data.format = "list-yes-no";
        params.data.labels = ["medication", "dosage", "timesPerDay"];
        params.data.options = {
          button: false,
          alphabetical: true
        };
        break;
      case "singleselect-other":
        const sselectBlock = new Block(params);
        if((((sselectBlock._option || {})._element || {}).textInputEl || {}).setAutoFocus){
          sselectBlock._option._element.textInputEl.setAutoFocus(false);
        }
        return sselectBlock;
      default:
    }

    params.data.id = (_self.value || {}).id;

    return new Block(params);
  }

  handle(type, value) {
    if (this.typingIndicator) {
      this.elContainer.removeELM(this.typingIndicator);
      this.typingIndicator = null;
    }

    // update progress bar
    if (value.progress) {
      ProgressBar.updateProgress(value.progress);
    }
    const _elm = this.handleOnMessage(value);
    if (value.status == 'typing') {
      console.log('typing')
    }

    if (!_elm) return;
    this.elContainer.innerHTML = "";
    this.elContainer.addELM(new Provider({ data: value }));
    //add medication list
    const elemsToAdd = [];

    if (value.values.latestMedication) {
        elemsToAdd.push(this.drawLastMedication(value.values.latestMedication))
    } else if (value.values.format !== "medication-list" && value.values.medication) {
      //add list
      let params = {
        values: { format: "selected-list", values: value.values.medication }
      };
      let list = this.mapFormat(params);
      elemsToAdd.push(list);
    }

    elemsToAdd.push(_elm);

    for (const addEl of elemsToAdd) {

      if(addEl._option && addEl._option._element && addEl._option._element.reset)
        addEl._option._element.reset();

      this.elContainer.addELM(addEl);
    }

    // add show more button
    // this.showMore(_elm.getELM());
    this.showMore(this.elContainer);

    if (value.status !== "typing"
      && (value.values || {}).format != 'list-yes-no'
      && (value.values || {}).format != 'medication-list') {
        if((value.values || {}).format === 'singleselect-other' || (value.values || {}).format === 'confirm') {
          const sTo = this.elContainer.offsetTop;
          Scroller.smoothScrollTo(sTo, 200, () => {});
          return;
        }

        Scroller.scrollToEnd(20, () => {
          _elm.focus();
        });
    }
  }

  handleOnMessage(value) {
    //const data = value.values;
    let component = null;

    if (value.format === "empty") return null;

    let identifier = value.values.id;

    if (identifier.indexOf("/answer") > -1) {
      const idParts = identifier.split("/answer/");
      identifier = idParts[0] + "/" + idParts[1];
      const question = this.contentHash[identifier][1];
      question.updateAnswer(value.values, this.clearAfterId.bind(this));
    } else if (!this.contentHash[identifier]) {
      component = this.mapFormat(value);
      if (value.status === "typing" || value.id.indexOf("/") === -1) {
        this.typingIndicator = component;
        identsplit = (identifier || "").split("suggestions/");
        identifier = identsplit[0] + identsplit[1];
        component = this.contentHash[identifier][1];
        if (
          value.continue === false &&
          component._option._element.updateSuggestions
        ) {
          this.typingIndicator = null;
          component._option._element.updateSuggestions(
            (value.values || []).suggestions
          );
          return;
        }
      } else {
        this.contentHash[identifier] = [
          Object.keys(this.contentHash).length,
          component
        ];
      }
    } else {
      //AR: just return the current value
      // component = this.contentHash[identifier][1];
      // this.elContainer.innerHTML = "";
      // this.elContainer.addELM(new Provider({ data: value }));
      // if (
      //   value.values &&
      //   value.values.error &&
      //   component._option._element.handleOnError
      // ) {
      //   component._option._element.handleOnError(value.values.error);
      // }

      //CA: we need to do this to update the values of the question when you edit medication
      component = this.mapFormat(value);

      this.contentHash[identifier] = [
        Object.keys(this.contentHash).length,
        component
      ];
    }

    if (value.status === "typing" || value.id.indexOf("/") === -1) {
      this.typingIndicator = component;
    }

    return component;
  }

  getHTML() {
    return this.elContainer;
  }

  getELM() {
    return this.elContainer;
  }

  clearAfterId(id) {
    const index = this.contentHash[id][0];
    const newHash = {};

    Object.keys(this.contentHash).forEach(key => {
      const ch = this.contentHash[key];
      if (ch[0] >= index) {
        this.elContainer.removeELM(ch[1]);
      } else {
        newHash[key] = ch;
      }
    });

    this.contentHash = newHash;
  }
  showMore(elm) {
    const height = getWindowHeight();
    const bound = elm.getBoundingClientRect();

    if (bound.height > height) {
      elm.defaultOffset = 100;
      ScrollNotification.attachElement(elm);
    }
  }

  scrollToFirstItem() {
    Scroller.scrollToElm(this);
  }

  drawLastMedication(medication) {
    const lastMedication = cELM("div", "meds-edit-wrapper");
    const editBtnWrapper = cELM("div", "edit-wrapper")
    const editButton = cELM("div", "edit-med button", getLngTxt('button.edit'));
    editBtnWrapper.addELM(editButton)
    const medWrapperDiv = cELM("div", "med-name");
    const medDiv = cELM("div", "", medication.medication);
    const medDosageDiv = cELM("div", "med-dosage", medication.dosage);
    const medFreqDiv = cELM(
      "div",
      "frequency",
      parseTimesPerDay(medication)
    );
    medWrapperDiv.addELM(medDiv);
    medWrapperDiv.addELM(medDosageDiv);
    medWrapperDiv.addELM(medFreqDiv);
    lastMedication.addELM(medWrapperDiv)
    lastMedication.addELM(editBtnWrapper)

    editButton.value = medication.medication
    editButton.onclick = this.onEditClicked.bind(this)

    return lastMedication;
  }

  onDeleteClicked(evt) {
    const self = this;
    const element = evt.target;
    const value = element.value;
    confirmPop(
      {
        title: getLngTxt('popup.delete.medication.title'),
        content: getLngTxt('popup.delete.medication.content')
      },
      function(isConfirmed) {
        if (isConfirmed) {
          element.setAttribute("disabled", true);
          element.parent;
          element.parentNode.style.display = "none";
          Chat.default.send({
            medication: value,
            action: "startDelete",
            id: (self.value || {}).id
          });
        } else {
        }
      }
    );
  }

  onEditClicked(evt) {
    const self = this;
    const element = evt.target;
    const value = element.value;
    confirmPop(
      {
        title: getLngTxt('popup.edit.medication.title'),
        content: getLngTxt('popup.edit.medication.content')
      },
      function(isConfirmed) {
        if (isConfirmed) {
          element.setAttribute("disabled", true);
          element.parent;
          element.parentNode.style.display = "none";
          Chat.default.send({
            medication: value,
            action: "startEdit",
            id: (self.value || {}).id
          });
        } else {
        }
      }
    );
  }
}

function parseTimesPerDay(obj) {
  let tpday = "";
  if(obj && obj.timesPerDay){
    tpday = obj.timesPerDay;
  }

  if(!Number.isNaN(parseInt(tpday))) {
    tpday += `/${getLngTxt('medication.day')}`;
  }

  return tpday;
}

function formatMedsList(medication) {
  const list = [];
  if (medication.meds) {
    let values = Object.values(medication["meds"]);
    for (let index = 0; index < values.length; index++) {
      list.push({
        status: "yes",
        medication: values[index].medication,
        dosage: values[index].dosage,
        timesPerDay: parseTimesPerDay(values[index]),
        isNewlyAdded:values[index].isNewlyAdded
      });
    }
  }
  if (medication["no-meds"]) {
    let values = Object.values(medication["no-meds"]);
    for (let index = 0; index < values.length; index++) {
      list.push({
        status: "no",
        medication: values[index].medication,
        dosage: values[index].dosage,
        timesPerDay: parseTimesPerDay(values[index]),
        isNewlyAdded:values[index].isNewlyAdded
      });
    }
  }
  return list;
}

module.exports = MedicationModuleV20;
